import * as React from 'react'
import type { SVGProps } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgSearchModal = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="rgba(var(--app-ink-rgb), 0.19)"
    viewBox="0 0 300 124"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g filter="url(#SearchModal_svg__a)">
      <rect
        width={95}
        height={57}
        x={3.5}
        y={19}
        fill="url(#SearchModal_svg__b)"
        rx={5}
      />
      <rect
        width={94}
        height={56}
        x={4}
        y={19.5}
        stroke="var(--app-border-subtle)"
        rx={4.5}
      />
    </g>
    <rect
      width={59}
      height={5}
      x={11.5}
      y={55}
      fill="var(--app-surface-muted)"
      rx={2.5}
    />
    <rect
      width={42}
      height={5}
      x={11.5}
      y={63}
      fill="var(--app-surface-muted)"
      rx={2.5}
    />
    <g filter="url(#SearchModal_svg__c)">
      <rect
        width={95}
        height={57}
        x={102.5}
        y={19}
        fill="url(#SearchModal_svg__d)"
        rx={5}
      />
      <rect
        width={94}
        height={56}
        x={103}
        y={19.5}
        stroke="var(--app-border-subtle)"
        rx={4.5}
      />
    </g>
    <rect
      width={59}
      height={5}
      x={110.5}
      y={55}
      fill="var(--app-surface-muted)"
      rx={2.5}
    />
    <rect
      width={42}
      height={5}
      x={110.5}
      y={63}
      fill="var(--app-surface-muted)"
      rx={2.5}
    />
    <g filter="url(#SearchModal_svg__e)">
      <rect
        width={95}
        height={57}
        x={201.5}
        y={19}
        fill="url(#SearchModal_svg__f)"
        rx={5}
      />
      <rect
        width={94}
        height={56}
        x={202}
        y={19.5}
        stroke="var(--app-border-subtle)"
        rx={4.5}
      />
    </g>
    <rect
      width={59}
      height={5}
      x={209.5}
      y={55}
      fill="var(--app-surface-muted)"
      rx={2.5}
    />
    <rect
      width={42}
      height={5}
      x={209.5}
      y={63}
      fill="var(--app-surface-muted)"
      rx={2.5}
    />
    <g filter="url(#SearchModal_svg__g)">
      <path
        fill="var(--app-text-secondary)"
        d="M166.226 74.115a44.69 44.69 0 0 0-6.959-60.341 44.686 44.686 0 0 0-73.741 32.238 44.688 44.688 0 0 0 71.096 37.714h-.007q.302.413.674.79l26.468 26.47a6.875 6.875 0 0 0 9.725.003 6.88 6.88 0 0 0 .004-9.725l-26.469-26.468a7 7 0 0 0-.791-.681M168 47.688a37.82 37.82 0 0 1-23.342 34.934 37.82 37.82 0 0 1-41.208-8.197A37.813 37.813 0 1 1 168 47.688"
      />
    </g>
    <defs>
      <filter
        id="SearchModal_svg__a"
        width={101}
        height={63}
        x={0.5}
        y={18}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={1.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12946_18251"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_12946_18251"
          result="shape"
        />
      </filter>
      <filter
        id="SearchModal_svg__c"
        width={101}
        height={63}
        x={99.5}
        y={18}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={1.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12946_18251"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_12946_18251"
          result="shape"
        />
      </filter>
      <filter
        id="SearchModal_svg__e"
        width={101}
        height={63}
        x={198.5}
        y={18}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={1.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12946_18251"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_12946_18251"
          result="shape"
        />
      </filter>
      <filter
        id="SearchModal_svg__g"
        width={124.004}
        height={123.989}
        x={78.494}
        y={0.013}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={3.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12946_18251"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_12946_18251"
          result="shape"
        />
      </filter>
      <linearGradient
        id="SearchModal_svg__b"
        x1={98.5}
        x2={-4}
        y1={68.5}
        y2={16.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--app-glass-surface-strong)" />
        <stop offset={1} stopColor="var(--app-widget-content-surface)" />
      </linearGradient>
      <linearGradient
        id="SearchModal_svg__d"
        x1={197.5}
        x2={95}
        y1={68.5}
        y2={16.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--app-accent-soft)" />
        <stop offset={1} stopColor="var(--app-accent-soft-strong)" />
      </linearGradient>
      <linearGradient
        id="SearchModal_svg__f"
        x1={296.5}
        x2={194}
        y1={68.5}
        y2={16.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--app-glass-surface-strong)" />
        <stop offset={1} stopColor="var(--app-widget-content-surface)" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgSearchModal
